import React, { Fragment, useState, useEffect } from "react";
import tools from "../../components/tools/tools";
import Select from '../../components/select';
import Loader from '../common/loader';
import { useNavigate } from 'react-router-dom'; // Import navigation hook
import '../../assets/scss/components/checkbox.scss'; // Import the SCSS file

const Default = ({
    esMesaRegistro,
}) => {
    const [printers, setPrinters] = useState([]);
    const [events, setEvents] = useState([]);
    const [psp, setPSP] = useState([]);
    const [selectedPrinterEtiquetas, setSelectedPrinterEtiquetas] = useState('');
    const [selectedPrinterDinamicas, setSelectedPrinterDinamicas] = useState('');
    const [selectedEvent, setSelectedEvent] = useState('');
    const [selectedPSP, setSelectedPSP] = useState('');
    const [labelWidth, setLabelWidth] = useState(''); 
    const [labelHeight, setLabelHeight] = useState(''); 
    const [ticketWidth, setTicketWidth] = useState(''); 
    const [ticketHeight, setTicketHeight] = useState(''); 
    const [fontSizeName, setFontSizeName] = useState(''); 
    const [fontSizeCompany, setFontSizeCompany] = useState(''); 
    const [fontSizeOther, setFontSizeOther] = useState(''); 
    const [printerStatus, setPrinterStatus] = useState(null); // null = no printer selected, true = connected, false = disconnected
    const [isMesaExpositor, setIsMesaExpositor] = useState(false); // State for "Es Mesa Expositor"
    const [manualSearch, setManualSearch] = useState(false); // State for "Activar Buscador Manual"
    const [activeCarnets, setActiveCarnets] = useState([]); // State to store active carnets
    const [checkboxData, setCheckboxData] = useState({}); // State to store checkbox data
    const navigate = useNavigate(); 

    async function fetchPrinters() {
        const button = document.getElementById('btnBuscarImpresora');
        if (button) button.disabled = true;
        if (!window.eventos) {
            if (button) button.disabled = false;
            return tools.notie.alert({
                type: 'error',
                text: 'No fue posible recuperar las impresoras instaladas en el sistema.',
                time: 5,
            });
        }
        try {
            let impresoras = await window.eventos.getPrinters();
            console.log('Respuesta de getPrinters:', impresoras);
            
            if (impresoras && impresoras.error) {
                console.error('Error en getPrinters:', impresoras.error);
                if (button) button.disabled = false;
                return tools.notie.alert({
                    type: 'error',
                    text: 'Error al obtener impresoras: ' + impresoras.error,
                    time: 5,
                });
            }
            
            if (!impresoras || !Array.isArray(impresoras) || impresoras.length === 0) {
                console.warn('No se encontraron impresoras');
                if (button) button.disabled = false;
                return tools.notie.alert({
                    type: 'warning',
                    text: 'No se encontraron impresoras instaladas en el sistema. Asegúrate de que tengas impresoras configuradas.',
                    time: 5,
                });
            }
            
            const transformedDevices = impresoras.map(impresora => ({
                clave: impresora.name,
                label: impresora.name,
                value: impresora.name
            }));
            setPrinters(transformedDevices);

            const isPrinterDetected = impresoras.some(printer => printer.name === selectedPrinterEtiquetas);
            setPrinterStatus(isPrinterDetected);

            if (button) button.disabled = false;
            
            tools.notie.alert({
                type: 'success',
                text: `Se encontraron ${impresoras.length} impresoras disponibles.`,
                time: 3,
            });
            
        } catch (error) {
            console.error('Error al llamar getPrinters:', error);
            if (button) button.disabled = false;
            return tools.notie.alert({
                type: 'error',
                text: 'Error inesperado al buscar impresoras: ' + error.message,
                time: 5,
            });
        }
    };

    function selectEve(value){
        setSelectedEvent(value)
        console.log(467, value)
        fetch('/rt_ctg_psp', {
            method: 'POST',
            headers: {"Content-Type":"application/json"},
            body: JSON.stringify({id_eve: value})
        }).then(response => response.json())
        .then(async (response) => {
            console.log(3333, response.psp)
            setPSP(response.psp);
        })
        .catch(async (err) => {
            console.log(err)
        })
    }

    useEffect(() => {
        fetch('/rt_ctg_eve', {
            method: 'POST',
            headers: {"Content-Type":"application/json"}
        }).then(response => response.json())
        .then(async (response) => {
            console.log(3333, response.eventos)
            setEvents(response.eventos);
        })
        .catch(async (err) => {
            console.log(err)
        })
    }, []);

    useEffect(() => {
        let flag = false
        console.log(444, events)
        if(events != null){
            flag = true
        }
    }, [events]);

    useEffect(() => {
        async function loadConfiguration() {
            if (window.eventos) {
                const response = await window.eventos.leerConfiguracion();
                if (response.estado === 'OK' && response.datos) {
                    const config = response.datos;
                    console.log(1001, config);
                    setSelectedEvent(config.selectedEvent || '');
                    setSelectedPSP(config.selectedPSP || '');
                    setSelectedPrinterEtiquetas(config.selectedPrinterEtiquetas || '');
                    setSelectedPrinterDinamicas(config.selectedPrinterDinamicas || '');
                    setLabelWidth(config.labelWidth || '');
                    setLabelHeight(config.labelHeight || '');
                    setTicketWidth(config.ticketWidth || '');
                    setTicketHeight(config.ticketHeight || '');
                    setFontSizeName(config.fontSizeName || '');
                    setFontSizeCompany(config.fontSizeCompany || '');
                    setFontSizeOther(config.fontSizeOther || '');
                    setIsMesaExpositor(config.isMesaExpositor || false); 
                    setManualSearch(config.manualSearch || false); 

                    // Buscar impresoras si hay alguna configurada
                    if (config.selectedPrinterEtiquetas || config.selectedPrinterDinamicas) {
                        fetchPrinters();
                    }
                }
            }
        }
        loadConfiguration();
    }, []);

    useEffect(() => {
        const checkPrinterStatus = async () => {
            if (!window.eventos || !selectedPrinterEtiquetas) {
                setPrinterStatus(null); // No printer selected
                return;
            }
            let impresoras = await window.eventos.getPrinters();
            const isPrinterDetected = impresoras.some(printer => printer.name === selectedPrinterEtiquetas);
            setPrinterStatus(isPrinterDetected); 
        };
        checkPrinterStatus();
    }, [selectedPrinterEtiquetas]);

    useEffect(() => {
        async function fetchActiveCarnets() {
            try {
                const response = await fetch('/rt_carnets_activos', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' }
                });
                const data = await response.json();
                if (data.status == 1) {
                    setActiveCarnets(data.carnets || []);
                    console.log('Active Carnets:', data.carnets);
                    
                    // After fetching carnets, load checkbox data
                    fetchCheckboxData();
                } else {
                    console.error('Error fetching active carnets:', data.message || data);
                }
            } catch (error) {
                console.error('Error fetching active carnets:', error);
            }
        }

        fetchActiveCarnets();
    }, []);

    useEffect(() => {
        console.log("checkboxData state has been updated to:", checkboxData);
    }, [checkboxData]);

    const fetchCheckboxData = async () => {
        try {
            const response = await fetch('/rt_load_checkbox_data', {
                method: 'GET',
                headers: { 'Content-Type': 'application/json' }
            });
            const result = await response.json();
            console.log("Fetched checkbox data from server:", result);
            
            if (result.estatus === 1 && result.data) { 
                console.log("Setting checkboxData state with:", result.data);
                setCheckboxData(result.data);
            } else {
                console.error('Failed to load checkbox data or data is empty:', result.message || result);
                setCheckboxData({}); 
            }
        } catch (error) {
            console.error('Error fetching/processing checkbox data:', error);
            setCheckboxData({}); 
        }
    };

    const handleSaveCheckboxData = () => {
        tools.notie.confirm({
            text: '¿Está seguro de que desea guardar la configuración de etiquetas?, esto afectará a todos los modulos del evento.',
            submitText: 'Sí',
            cancelText: 'No',
            position: 'top',
            submitCallback: () => { 
                console.log('User confirmed (submitCallback), proceeding to save checkbox configuration.');
                const currentCheckboxData = {};
                
                activeCarnets.forEach((carnet) => {
                    const carnetId = carnet.VALOR_TPO;
                    currentCheckboxData[carnetId] = {
                        Nombre: document.getElementById(`checkbox-n-${carnetId}`)?.checked ? 1 : 0,
                        Apellido: document.getElementById(`checkbox-a-${carnetId}`)?.checked ? 1 : 0,
                        Empresa: document.getElementById(`checkbox-e-${carnetId}`)?.checked ? 1 : 0,
                        Qr: document.getElementById(`checkbox-q-${carnetId}`)?.checked ? 1 : 0,
                        Cenas: document.getElementById(`checkbox-c-${carnetId}`)?.checked ? 1 : 0,
                    };
                });

                fetch('/rt_save_checkbox_data', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(currentCheckboxData),
                })
                .then((response) => response.json())
                .then((result) => {
                    if (result.status === 1) {
                        console.log('Checkbox data saved successfully');
                        setCheckboxData(currentCheckboxData);
                        tools.notie.alert({
                            type: 'success',
                            text: 'Configuración de campos guardada exitosamente.',
                            time: 3,
                            position: 'top'
                        });
                    } else {
                        console.error('Error saving checkbox data:', result.message);
                        tools.notie.alert({
                            type: 'error',
                            text: `Error al guardar configuración de campos: ${result.message}`,
                            time: 3,
                            position: 'top'
                        });
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                    tools.notie.alert({
                        type: 'error',
                        text: `Error al guardar configuración de campos: ${error.toString()}`,
                        time: 3,
                        position: 'top'
                    });
                });
            },
            cancelCallback: () => { // Callback for when the "No" button is clicked
                console.log('User canceled (cancelCallback), not saving checkbox configuration.');
                // Optionally, provide feedback that the action was canceled
                // tools.notie.alert({ type: 'info', text: 'Guardado de configuración de campos cancelado.', time: 2, position: 'top' });
            }
        });
    };

    const handleReturn = () => {
        navigate('/mesaregistro');
    };

    const handleLabelWidthChange = (e) => {
        const value = e.target.value;
        setLabelWidth(value);
    };

    const handleLabelHeightChange = (e) => {
        const value = e.target.value;
        setLabelHeight(value);
    };

    const handleCheckboxChange = (id, field, isChecked) => {
        setCheckboxData((prevData) => ({
            ...prevData,
            [id]: {
                ...prevData[id],
                [field]: isChecked ? 1 : 0,
            },
        }));
    };

    const handleSelectAll = (isChecked) => {
        const updatedCheckboxData = {};
        activeCarnets.forEach((carnet) => {
            updatedCheckboxData[carnet.VALOR_TPO] = {
                Nombre: isChecked ? 1 : 0,
                Apellido: isChecked ? 1 : 0,
                Empresa: isChecked ? 1 : 0,
                Qr: isChecked ? 1 : 0,
                Cenas: isChecked ? 1 : 0,
            };
        });
        setCheckboxData(updatedCheckboxData);
    };

    const handleColumnToggle = (field) => {
        const fieldToPrefix = {
            'Nombre': 'checkbox-n-',
            'Apellido': 'checkbox-a-',
            'Empresa': 'checkbox-e-',
            'Qr': 'checkbox-q-',
            'Cenas': 'checkbox-c-'
        };
        
        const prefix = fieldToPrefix[field];
        if (!prefix) return;
        
        const checkboxes = document.querySelectorAll(`[id^="${prefix}"]`);
        
        const allChecked = Array.from(checkboxes).every(cb => cb.checked);
        
        checkboxes.forEach(checkbox => {
            checkbox.checked = !allChecked;
            
            const carnetId = checkbox.id.split('-')[2]; 
            
            if (carnetId) {
                handleCheckboxChange(carnetId, field, !allChecked);
            }
        });
    };

    const handleRowToggle = (carnetId) => {
        const prefixes = ['checkbox-n-', 'checkbox-a-', 'checkbox-e-', 'checkbox-q-', 'checkbox-c-'];
        
        const rowCheckboxes = [];
        prefixes.forEach(prefix => {
            const checkbox = document.getElementById(`${prefix}${carnetId}`);
            if (checkbox) {
                rowCheckboxes.push(checkbox);
            }
        });
        
        const allChecked = rowCheckboxes.length > 0 && rowCheckboxes.every(cb => cb.checked);
        
        rowCheckboxes.forEach(checkbox => {
            checkbox.checked = !allChecked;
            
            const fieldPrefix = checkbox.id.split('-')[1];
            let field;
            
            switch(fieldPrefix) {
                case 'n': field = 'Nombre'; break;
                case 'a': field = 'Apellido'; break;
                case 'e': field = 'Empresa'; break;
                case 'q': field = 'Qr'; break;
                case 'c': field = 'Cenas'; break;
                default: return;
            }
            
            handleCheckboxChange(carnetId, field, !allChecked);
        });
    };

    const handleToggleAllCheckboxes = () => {
        const allCheckboxes = document.querySelectorAll('input[id^="checkbox-"]');
        
        const allChecked = Array.from(allCheckboxes).every(cb => cb.checked);
        
        allCheckboxes.forEach(checkbox => {
            checkbox.checked = !allChecked;
            
            const [_, fieldPrefix, carnetId] = checkbox.id.split('-');
            let field;
            
            switch(fieldPrefix) {
                case 'n': field = 'Nombre'; break;
                case 'a': field = 'Apellido'; break;
                case 'e': field = 'Empresa'; break;
                case 'q': field = 'Qr'; break;
                case 'c': field = 'Cenas'; break;
                default: return;
            }
            
            handleCheckboxChange(carnetId, field, !allChecked);
        });
        
        handleSelectAll(!allChecked);
    };

    return (
        
        <div className="container d-flex justify-content-center" style={{ maxWidth: '80%', backgroundColor: '#f2f2f5', color: '#000' }}>
            <Fragment>
                <button 
                    onClick={handleReturn} 
                    className="btn btn-secondary" 
                    style={{ position: 'absolute', top: '10px', left: '10px' }}
                >
                    Regresar
                </button>
                <Loader status={events}/>
                <div className="col-sm-10 mt-5 registros-nuevos"> {/* Adjusted width */}
                    <div className="card mt-5" style={{ backgroundColor: '#fff', color: '#000' }}>
                        <div className="card-header p-0 mt-3">
                            <div className='row p-0 m-0 d-flex justify-content-center'>
                                <div className="col-sm-10 p-0 m-0 d-flex justify-content-center">
                                    <h5>Configuración Etiquetas</h5> {/* Updated title */}
                                </div>
                            </div>
                        </div>
                        <div className="card-body">
                            
                            <div className="row mb-4">
                                <div className="col-md-12 d-flex justify-content-center">
                                    <table className="table table-bordered text-center" style={{ width: '80%' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ width: '10%', cursor: 'pointer' }} onClick={handleToggleAllCheckboxes}>
                                                    ID
                                                </th>
                                                <th style={{ width: '20%' }}>Tipo Carnet</th>
                                                <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => handleColumnToggle('Nombre')}>
                                                    Nombre
                                                </th>
                                                <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => handleColumnToggle('Apellido')}>
                                                    Apellido
                                                </th>
                                                <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => handleColumnToggle('Empresa')}>
                                                    Empresa
                                                </th>
                                                <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => handleColumnToggle('Qr')}>
                                                    QR
                                                </th>
                                                <th style={{ width: '15%', cursor: 'pointer' }} onClick={() => handleColumnToggle('Cenas')}>
                                                    Cenas
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {activeCarnets.map((carnet, index) => {
                                                const carnetID = carnet.VALOR_TPO;
                                                const dataForThisCarnet = checkboxData[carnetID];
                                                return (
                                                <tr key={carnetID}>
                                                    <td onClick={() => handleRowToggle(carnetID)} style={{ cursor: 'pointer' }}>
                                                        {carnetID}
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center">
                                                            {(() => {
                                                                const tipo = carnet.TIPO_CARNET ?? carnetID;
                                                                const idPsp = carnet.ID_PSP ?? carnet.ID_PSP;
                                                                const tipoText = carnet.TIPO_CARNET_TEXT ?? carnet.NOMBRE_TPO ?? carnetID;

                                                                if (tipo == 1 && idPsp == 89) {
                                                                    return <img src="/Premium.png" width={150} alt="Premium" />;
                                                                } else if (tipo == 1 && idPsp == 88) {
                                                                    return <img src="/Estudiante.png" width={150} alt="Estudiante" />;
                                                                } else if (tipo == 1 && idPsp == 87) {
                                                                    return <img src="/General.png" width={150} alt="General" />;
                                                                } else if (tipo === 2) {
                                                                    return <img src="/talleres.jpg" width={150} alt="Talleres" />;
                                                                } else if (tipo === 3) {
                                                                    return <img src="/Expositor.png" width={150} alt="Expositor" />;
                                                                } else if (tipo === 4) {
                                                                    return <img src="/Invitado-Especial.png" width={150} alt="Invitado Especial" />;
                                                                } else if (tipo === 5) {
                                                                    return <img src="/prensa.jpg" width={150} alt="Prensa" />;
                                                                } else if (tipo === 6) {
                                                                    return <img src="/Staff.png" width={150} alt="Staff" />;
                                                                } else if (tipo === 7 || tipo === 8) {
                                                                    return <img src="/cena.jpg" width={150} alt="Cena" />;
                                                                } else if (tipo === 11) {
                                                                    return <img src="/Ponente.png" width={150} alt="Ponente" />;
                                                                } else if (tipo === 12) {
                                                                    return <img src="/patrocinador.jpg" width={150} alt="Patrocinador" />;
                                                                } else if (tipo === 13) {
                                                                    return <img src="/claec.jpg" width={150} alt="Claec" />;
                                                                } else if (tipo === 9) {
                                                                    return <img src="/conferencias.jpg" width={150} alt="Conferencias" />;
                                                                } else if (tipo === 15) {
                                                                    return <img src="/convencionista-soloCB.jpg" width={150} alt="Convencionista Solo CB" />;
                                                                } else if (tipo === 16) {
                                                                    return <img src="/convencionista-sinC.jpg" width={150} alt="Convencionista Sin C" />;
                                                                } else if (tipo === 17) {
                                                                    return <img src="/apoyo-speaker.jpg" width={150} alt="Apoyo Speaker" />;
                                                                } else {
                                                                    return <h5><span className="badge badge-primary">Carnet {tipoText}</span></h5>;
                                                                }
                                                            })()}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                                                            <label className="modern-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-n-${carnetID}`}
                                                                    checked={!!(dataForThisCarnet && dataForThisCarnet.Nombre === 1)}
                                                                    onChange={(e) => handleCheckboxChange(carnetID, 'Nombre', e.target.checked)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                                                            <label className="modern-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-a-${carnetID}`}
                                                                    checked={!!(dataForThisCarnet && dataForThisCarnet.Apellido === 1)}
                                                                    onChange={(e) => handleCheckboxChange(carnetID, 'Apellido', e.target.checked)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                                                            <label className="modern-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-e-${carnetID}`}
                                                                    checked={!!(dataForThisCarnet && dataForThisCarnet.Empresa === 1)}
                                                                    onChange={(e) => handleCheckboxChange(carnetID, 'Empresa', e.target.checked)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                                                            <label className="modern-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-q-${carnetID}`}
                                                                    checked={!!(dataForThisCarnet && dataForThisCarnet.Qr === 1)}
                                                                    onChange={(e) => handleCheckboxChange(carnetID, 'Qr', e.target.checked)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center justify-content-center" style={{ height: '100%' }}>
                                                            <label className="modern-checkbox">
                                                                <input
                                                                    type="checkbox"
                                                                    id={`checkbox-c-${carnetID}`}
                                                                    checked={!!(dataForThisCarnet && dataForThisCarnet.Cenas === 1)}
                                                                    onChange={(e) => handleCheckboxChange(carnetID, 'Cenas', e.target.checked)}
                                                                />
                                                                <span className="checkmark"></span>
                                                            </label>
                                                        </div>
                                                    </td>
                                                </tr>
                                                );
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <hr />
                            <div className="row mb-4">
                                <div className="col-md-12 d-flex justify-content-center">
                                    <button onClick={() => { handleSaveCheckboxData(); }} className="btn btn-success">Guardar</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
                    </div>
    );
};

export default Default;

